export const types = {
  SET_THREATS: 'SET_THREATS',
};
